import Box from "react-raster";
import React from "react";
import styled from "styled-components";

import Container from "../Container";
import Statistic from "./Statistic";

const FullWidthWrapper = styled.div`
  width: 100%;
  padding-bottom: ${({ $hasBottomMargin }) =>
    $hasBottomMargin ? "60px" : "20px"};
  padding-top: ${({ $hasTopMargin }) => ($hasTopMargin ? "60px" : "20px")};
`;

function Statistics({ statistics, hasBottomMargin, hasTopMargin }) {
  return (
    <FullWidthWrapper
      $hasBottomMargin={hasBottomMargin}
      $hasTopMargin={hasTopMargin}
    >
      <Container>
        {statistics.map((stat, i) => {
          const isLast = i + 1 === statistics?.length;
          const isOdd = i % 2;
          return (
            <Box
              key={stat.id}
              cols={[6, 12, 6]}
              marginLeft={[0, 0, isOdd ? 1 : 5]}
              marginRight={[0, 0, isOdd ? 5 : 1]}
              marginBottom={isLast && "53px"}
            >
              <Statistic stat={stat} colour="blue" />
            </Box>
          );
        })}
      </Container>
    </FullWidthWrapper>
  );
}

export default Statistics;
